import React from 'react';

function Error() {
    return (
        <div className="empty">404 Page Not Found</div>
    );
}

export default Error;